/*
 * @Description: 项目详情
 * @Date: 2020-10-14 15:58:13
 * @LastEditors: Please set LastEditors
 */

import { agentManager } from '@/api/ajax';
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';

let example = new TableRenderClass({ fields, search });

let part = example.createPart({
  name: '项目详情',
  list: agentManager.listProjectUserDetail,
  search: [
    {
      width: 180,
      tip: '请输入项目名称',
      key: 'projectName',
      id: 'projectName',
      slot: 'input',
      clearable: true
    },
    {
      key: 'gongyeId',
      tip: '项目方',
      required: false,
      slot: 'ajaxSelect',
      clearable: true,
      prop: {
        label: 'gongyeName',
        code: 'gongyeId'
      },
      query: {
        type: 1
      },
      ajax: async data => {
        try {
          const res = await agentManager.listGongyeWithProjectUserForSelect(
            data
          );
          return res;
        } catch (error) {
          return error;
        }
      },
      ajaxQuery: 'keyWord',
      width: 180
    }
  ],
  requestNow: true,
  fields: [
    'index',
    'projectName',
    'gongyeName',
    'serviceProjectName',
    'isComplete',
    'settledStatus',
    'agentStatus',
    'userTag',
    'price',
    'csoPrice',
    'submitNum',
    'taskSumSurplus',
    'passingTaskSumPlatform',
    'passTaskSumPlatform',
    'passingTaskSum',
    'noFinishTaskSum',
    'userAmount',
    'prePurchaseProsces',
    'taskDts'
  ]
});

export default [{ name: '项目详情', childMenu: [part] }];
